package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class RssImportRequest(
    val rssUrl: String
)

@Serializable
data class RssImportPreview(
    val title: String,
    val author: String? = null,
    val narrator: String? = null,
    val description: String? = null,
    val coverImageUrl: String? = null,
    val language: String? = null,
    val isAudiobookIndicator: Boolean = false,
    val chapterCount: Int,
    val totalDurationSeconds: Int? = null,
    val chapters: List<RssChapterPreview> = emptyList()
)

@Serializable
data class RssChapterPreview(
    val number: Int,
    val title: String,
    val durationSeconds: Int? = null,
    val audioUrl: String,
    val narrator: String? = null
)

@Serializable
data class RssImportConfirmRequest(
    val rssUrl: String,
    val isbn: String? = null,
    val authorName: String? = null,
    val readerName: String? = null,
    val titleOverride: String? = null,
    val descriptionOverride: String? = null,
    val labelId: Int? = null
)

@Serializable
data class AudiobookDownloadStatus(
    val audiobookId: String,
    val totalChapters: Int,
    val completedChapters: Int,
    val failedChapters: Int,
    val pendingChapters: Int,
    val downloadingChapters: Int,
    val overallStatus: String,
    val chapters: List<ChapterDownloadStatus> = emptyList()
)

@Serializable
data class ChapterDownloadStatus(
    val episodeId: String,
    val episodeNumber: Int,
    val title: String,
    val downloadStatus: String,
    val downloadError: String? = null
)

@Serializable
data class ActiveDownloadSummary(
    val audiobookId: String,
    val audiobookTitle: String,
    val coverImageUrl: String? = null,
    val totalChapters: Int,
    val completedChapters: Int,
    val failedChapters: Int,
    val pendingChapters: Int,
    val downloadingChapters: Int,
    val overallStatus: String
)

@Serializable
data class ActiveDownloadsResponse(
    val inProgress: List<ActiveDownloadSummary> = emptyList(),
    val recentlyCompleted: List<ActiveDownloadSummary> = emptyList()
)

/**
 * Result of retrying an audiobook's failed/stalled downloads.
 * [queued] is 0 when everything was already complete or every candidate had exhausted
 * its retry attempts; [status] is the freshly reconciled state for the UI to render.
 */
@Serializable
data class RetryDownloadsResponse(
    val queued: Int,
    val status: AudiobookDownloadStatus
)
